import { SvgIcon } from '@mui/material';

import type { BaseIconProps } from '../types';

export const ClockIcon: React.FC<BaseIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 45 45" fillRule="evenodd" stroke="none" {...props}>
      <circle cx="22.5" cy="22.5" r="21.5" fill="none" stroke="currentColor" strokeWidth="2" />
      <line x1="22.75" y1="1.5" x2="22.75" y2="7.5" stroke="currentColor" strokeWidth="2" />
      <line x1="22.75" y1="38.25" x2="22.75" y2="44.25" stroke="currentColor" strokeWidth="2" />
      <line x1="43.5" y1="24.25" x2="37.5" y2="24.25" stroke="currentColor" strokeWidth="2" />
      <line x1="6.75" y1="24.25" x2="0.75" y2="24.25" stroke="currentColor" strokeWidth="2" />
      <line
        x1="33.259"
        y1="41.0861"
        x2="31.759"
        y2="38.488"
        stroke="currentColor"
        strokeWidth="2"
      />
      <line
        x1="11.509"
        y1="7.86011"
        x2="10.009"
        y2="5.26203"
        stroke="currentColor"
        strokeWidth="2"
      />
      <line
        x1="40.0859"
        y1="34.241"
        x2="37.4879"
        y2="32.741"
        stroke="currentColor"
        strokeWidth="2"
      />
      <line
        x1="6.11011"
        y1="14.741"
        x2="3.51203"
        y2="13.241"
        stroke="currentColor"
        strokeWidth="2"
      />
      <line
        x1="41.0859"
        y1="12.491"
        x2="38.4879"
        y2="13.991"
        stroke="currentColor"
        strokeWidth="2"
      />
      <line
        x1="7.86011"
        y1="33.491"
        x2="5.26203"
        y2="34.991"
        stroke="currentColor"
        strokeWidth="2"
      />
      <line
        x1="34.241"
        y1="4.91394"
        x2="32.741"
        y2="7.51202"
        stroke="currentColor"
        strokeWidth="2"
      />
      <line
        x1="13.991"
        y1="38.8899"
        x2="12.491"
        y2="41.488"
        stroke="currentColor"
        strokeWidth="2"
      />
      <line x1="22.75" y1="12" x2="22.75" y2="23.25" stroke="currentColor" strokeWidth="2" />
      <line x1="29.25" y1="23.5" x2="21.75" y2="23.5" stroke="currentColor" strokeWidth="2" />
    </SvgIcon>
  );
};
